import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const InvalidAccessModal = ({ isOpen }) => {
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const contentVariants = {
    hidden: {
      scale: 0.8,
      opacity: 0,
      transition: {
        type: "spring",
        damping: 30,
        stiffness: 300,
      },
    },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 25,
        stiffness: 300,
      },
    },
    exit: {
      scale: 0.8,
      opacity: 0,
      transition: {
        type: "spring",
        damping: 35,
        stiffness: 300,
      },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="invalid-access-modal-overlay"
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={overlayVariants}
          transition={{ duration: 0.25 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "20px",
          }}
        >
          <motion.div
            className="invalid-access-modal-content"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={contentVariants}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              padding: "32px 24px",
              maxWidth: "340px",
              width: "100%",
              textAlign: "center",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px auto",
              }}
            >
              <svg
                width="72"
                height="72"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="#F59E0B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#1F2937",
                margin: "0 0 0px 0",
                lineHeight: "1.4",
              }}
            >
              잘못된 접근입니다
            </h3>

            <p
              style={{
                fontSize: "15px",
                fontWeight: "400",
                color: "#6B7280",
                margin: "0",
                lineHeight: "1.6",
              }}
            >
              <br />
              관리사무소 또는 안내를 통해 전달받으신
              <br />
              링크 또는 QR을 통해 재접속해 주시기 바랍니다.
              <br />
              <br />
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InvalidAccessModal;
